import React from "react"
import styled from "styled-components"
import { Currencies } from "@orbital/games-frontend-library"

export default function OneBet({ name, bet, currency, cashout }: any) {
  return (
    <Wrapper cashout={cashout}>
      <span>{name}</span>{" "}
      <span>
        {Currencies[currency]}
        {cashout ? cashout : bet}
      </span>
    </Wrapper>
  )
}

export const Wrapper = styled.div<{ cashout: any }>`
  ${({ cashout }) =>
    cashout
      ? `background: #593B45;
         border: 1px solid #FFB000; 
         color: #FFB000 `
      : `background: #221243;
        border: 1px solid #160E28;
        color: #C7C7C7;`};

  display: flex;
  justify-content: space-between;
  width: 150px;
  height: 23px;
  border-radius: 100px;
  padding: 5px 10px;
  gap: 10px;
  margin-bottom: 6px;
  font-weight: 700;
  font-size: 10px;
  line-height: 13px;
  box-sizing: border-box;
  span {
    line-height: 1;
    :first-child {
      max-width: 70px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`
